<template>
  <div class="help">
    <div class="top">
      您好，
      <br />我们为您提供更多帮助……
    </div>
    <div class="content">
      <div class="title">常见问题</div>
      <van-cell
        v-for="(cell, index) in resource"
        :key="cell.title"
        :title="cell.title"
        is-link
        :to="`help/${index}?title=${cell.title}`"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { List, PullRefresh, Cell, CellGroup } from 'vant';
import { resource } from './resource';

Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Cell);
Vue.use(CellGroup);

export default {
  name: 'RecommendCenter',
  metaInfo: {
    title: '帮助中心',
  },
  data() {
    return {
      resource,
    };
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.top {
  background: #af72c5;
  color: #fff;
  font-size: 18px;
  line-height: 27px;
  font-weight: 700;
  padding: 26px 12px 34px 12px;
}
.content {
  position: relative;
  padding: 16px;
  top: -8px;
  background: #fff;
  border-radius: 8px 8px 0 0;
  color: rgba(51, 51, 51, 1);
  .title {
    font-weight: 500;
    font-size: 16px;
  }
  /deep/.van-cell {
    padding: 12px 0;
  }
  /deep/.van-cell:not(:last-child)::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 0px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}
</style>
